import { useMultiDocumentUploaderContext } from '../context/multiDocumentUploader.context';

export function useDocumentTypesValidation(): boolean {
  const { uploadedFiles, fileIDTypeMap } = useMultiDocumentUploaderContext();

  if (uploadedFiles.length === 0) {
    return true;
  }

  return uploadedFiles.every((file) => {
    const documentType = fileIDTypeMap[file.fileId];
    return documentType !== undefined && documentType !== '';
  });
}
